import AllPools from './AllPools';
// import { CosmicPools } from './CosmicPools';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { cn } from 'utils/cn';

import Tabs from 'components/ui/tabs/Tabs';

import { MyPositions } from 'components/composed/MyPositions/MyPositions';
// import { SateliteIcon } from 'components/Icons';
import PoolsContentWrapper from 'components/composed/Pools/PoolsContentWrapper';
import PoolsWrapper from 'components/composed/Pools/PoolsWrapper';

type TabId = 'all-pools' | 'my-pools';

const defaultTabId: TabId = 'all-pools';

const isValidTabId = (tabId: string | null): tabId is TabId =>
  tabId === 'all-pools' || tabId === 'my-pools';

const Pool = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const initialTabId = searchParams.get('tabId');

  const [activeTabID, setActiveTabID] = useState<TabId>(
    isValidTabId(initialTabId) ? initialTabId : defaultTabId
  );

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('tabId', activeTabID);

    navigate({ search: newSearchParams.toString() }, { replace: true });
  }, [activeTabID, navigate, location.search]);

  const handleTabChange = (tabId: string) => {
    if (isValidTabId(tabId)) {
      setActiveTabID(tabId);
    }
  };

  return (
    <div
      className={cn('w-full px-5 pt-9', {
        'max-w-120': activeTabID === 'my-pools',
        'max-w-140': activeTabID === 'all-pools'
      })}
    >
      <PoolsWrapper
        className={activeTabID === 'my-pools' ? 'max-w-120' : 'max-w-140'}
      >
        <Tabs
          activeTabId={activeTabID}
          onTabChange={handleTabChange}
          className='absolute -top-5.75 left-1/2 z-10 w-45 -translate-x-1/2'
          // Cosmic reference
          // className='absolute -top-5.75 left-1/2 z-10 w-63.5 -translate-x-1/2'
          size='sm'
          tabs={[
            {
              id: 'all-pools',
              children: <span className='z-10 -ml-0.5'>All Pools</span>
            },
            /* Cosmic reference */
            // {
            //   id: 'cosmic',
            //   children: (
            //     <span className='z-10 -ml-0.5 -mr-0.5 flex flex-row items-center gap-1'>
            //       <SateliteIcon className='size-4 stroke-gray-600 group-hover:stroke-blue-200 group-data-[state=active]:stroke-blue-200' />
            //       Cosmic
            //     </span>
            //   )
            // },
            {
              id: 'my-pools',
              children: <span className='z-10 -mr-0.5'>My Pools</span>
            }
          ]}
        />

        <PoolsContentWrapper>
          {activeTabID === 'all-pools' && <AllPools />}
          {/* {activeTabID === 'cosmic' && <CosmicPools />} */}
          {activeTabID === 'my-pools' && <MyPositions />}
        </PoolsContentWrapper>
      </PoolsWrapper>
    </div>
  );
};

export default Pool;
